<template>
  <section v-if="isValid" :id="container">
    <script type="application/javascript">_tla('{{action}}', '{{zoneId}}', '{{container}}');</script>
  </section>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue
} from 'vue-property-decorator';

@Component
export default class PublisherContentComponent extends Vue {
  @Prop({ default: '' })
  public propId!: string;

  @Prop({ default: '' })
  public action!: string;

  @Prop({ default: '' })
  public zoneId!: string;

  @Prop({ default: '' })
  public container!: string;

  public get isValid(): boolean {
    return this.action.length > 0 && this.zoneId.length > 0 && this.container.length > 0;
  }
}
</script>
